import React from 'react';
import { SectionShell } from './SectionShell';
export function Stakeholders() {
  return <SectionShell number="05" title="Stakeholder ownership" tone="light" data-id="element-138" data-mp="k4f32u6uz43m">
      <div className="grid grid-cols-12 gap-16" data-id="element-139" data-mp="k2ki5fvl7bzj">
        <div className="col-span-7 space-y-8" data-id="element-140" data-mp="owos8805g04u">
          <p className="font-display text-2xl font-medium leading-snug tracking-tight text-ink" data-id="element-141" data-mp="oxzug3dy4ztu">
            I owned this end to end, across every touchpoint.
          </p>
          <p className="text-lg leading-[1.75] text-ink/80" data-id="element-142" data-mp="3se6vs38w2kzg">
            I worked with Heads of Department and the C-suite to build a marketing calendar covering external
            campaigns and internal asset needs across the business, so brand work was planned against what the
            organisation actually needed each quarter rather than being reactive.
          </p>
          <p className="text-lg leading-[1.75] text-ink/80" data-id="element-143" data-mp="1hjj78pe767ax">
            I worked directly with the CEO and presented to the full stakeholder group, where we shaped and
            moved the rebrand forward together rather than me presenting finished work for approval after the
            fact.
          </p>
          <div className="border-l-2 border-accent-purple pl-8" data-id="element-144" data-mp="1se75uwb417mq">
            <h3 className="font-display text-[11px] font-semibold uppercase tracking-[0.18em] text-accent-purple" data-id="element-145" data-mp="1obkhj5dne4ua">
              Holding the line
            </h3>
            <p className="mt-4 text-lg leading-[1.75] text-ink/80" data-id="element-146" data-mp="1jfbxpeoi9ngs">
              One of the most important things I did was push back on aggressive deadlines to ensure the rebrand
              wasn’t just delivered quickly, but delivered well. That gave us time to consider the people behind
              the change, creating space for communication, adoption and helping colleagues embrace the new
              identity rather than simply rolling it out.
            </p>
          </div>
        </div>

        <aside className="col-span-5 bg-paper-grey p-10" data-id="element-147" data-mp="vp9d1jmx7js7">
          <h3 className="font-display text-sm font-semibold uppercase tracking-[0.22em] text-ink/50" data-id="element-148" data-mp="qpmz17z9pzic">
            Where I operated
          </h3>
          <ul className="mt-8 space-y-6" data-id="element-149" data-mp="lzswvlpjzgon">
            {['Directly with the CEO', 'Full stakeholder group presentations', 'Heads of Department, quarterly planning', 'Marketing calendar ownership, external and internal'].map(item => <li key={item} className="flex gap-4 border-b border-ink/10 pb-6 text-[15px] text-ink/80" data-id="element-150" data-mp="zrh9dq3ps765">
                <span className="mt-[9px] h-[5px] w-[5px] shrink-0 bg-accent-purple" aria-hidden="true" data-id="element-151" data-mp="14qtt41zagy4i" />
                <span data-id="element-152" data-mp="q26125onj6jb">{item}</span>
              </li>)}
          </ul>
        </aside>
      </div>
    </SectionShell>;
}